import apiCall from '@/utils/api-call'
import Urls from '@/router/urls'

export default {
  clearAuthToken ({ commit }) {
    commit('SET_AUTH_TOKEN', null)
  },

  refreshAuthToken ({ commit, getters }) {
    if (!getters.authToken) {
      return false
    }

    return apiCall.post(Urls.Auth.Refresh)
      .then(res => {
        commit('SET_AUTH_TOKEN', res.data.token)
        commit('SET_LAST_REFRESH_TIME', Math.round(new Date() / 1000))
      })
  },

  login ({ commit }, params) {
    return apiCall.post(Urls.Auth.Login, params)
      .then(res => {
        commit('SET_USER_DATA', res.data)

        if (res.data.token) {
          commit('SET_LAST_REFRESH_TIME', Math.round(new Date() / 1000))
          commit('SET_AUTH_TOKEN', res.data.token)
          commit('SET_TOKEN_EXPIRE_IN_MINUTES', res.data.jwt_token_duration_minutes)
        }

        if (res.data.tenants && res.data.tenants.length === 1) {
          commit('SET_USER_TENANT_ID', res.data.tenants[0])
          return true
        }

        return false
      })
  },

  loginSSO ({ commit }, params) {
    commit('SET_AUTH_TOKEN', params.token)

    return apiCall.get(Urls.Auth.LoginSSO)
      .then(res => {
        commit('SET_USER_DATA', res.data)

        if (res.data.token) {
          commit('SET_LAST_REFRESH_TIME', Math.round(new Date() / 1000))
          commit('SET_AUTH_TOKEN', res.data.token)
          commit('SET_TOKEN_EXPIRE_IN_MINUTES', res.data.jwt_token_duration_minutes)
        }

        const tenants = res.data.tenants || []

        if (params.tenantId) {
          // if tenantID is set from query param of url, check and select it
          const tenant = tenants.find(t => t === params.tenantId)
          if (tenant) {
            commit('SET_USER_TENANT_ID', params.tenantId)
            return true
          }
        }

        if (tenants.length === 1) {
          commit('SET_USER_TENANT_ID', res.data.tenants[0])
          return true
        }

        return false
      })
  },

  saveLoginLog () {
    return apiCall.post(Urls.Auth.LoginLog)
  },

  logout ({ commit }) {
    commit('SET_AUTH_TOKEN', null)
    commit('SET_LAST_REFRESH_TIME', 0)
    commit('SET_LAST_ACTION_TIME', 0)
    commit('RESET')
  },

  setLastActionTime ({ commit }, payload) {
    commit('SET_LAST_ACTION_TIME', payload)
  },

  setUserTenantId ({ commit }, payload) {
    commit('SET_USER_TENANT_ID', payload)
  }
}
